module.exports = __webpack_public_path__ + "img/markero-registration.6244589a.png";